import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";

const SPAN_CLS = {
  normal: "",
  wide: "col-span-2",
  tall: "row-span-2",
  big: "col-span-2 row-span-2",
};

export function Gallery() {
  const { t } = useLang();
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-28 lg:py-40 bg-[#F3EFE7] border-t border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p className="text-xs uppercase tracking-[0.35em] text-[#555] mb-6"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          {t.gallery.overline}
        </motion.p>
        <motion.h2 data-testid="gallery-title" className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-14"
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, delay: 0.1 }}>
          {t.gallery.title}
        </motion.h2>

        <div data-testid="gallery-grid" className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[160px] sm:auto-rows-[200px] lg:auto-rows-[220px] gap-3">
          {photos.map((img, i) => (
            <motion.div
              key={img.id}
              data-testid={`gallery-item-${i}`}
              className={`overflow-hidden group ${SPAN_CLS[img.span] || ""}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: Math.min(i * 0.08, 0.5) }}
            >
              <img
                src={img.url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${img.url}` : img.url}
                alt={img.alt || "Funghetto Roma"}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
